import gsap from "gsap";
import {DrawSVGPlugin} from "gsap/DrawSVGPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";

export default class Line {
  constructor() {
    this._line = document.querySelector("#floating_line path");

    if (this._line) {
      this.init();
    }
  }

  init() {
    gsap.registerPlugin(DrawSVGPlugin);
    gsap.registerPlugin(ScrollTrigger);


    let isHomePage = document.body.classList.contains('home');
    let start, end, scrub;

    if (isHomePage) {
      start = "top+=6% bottom";
      end = "bottom bottom";
      scrub = 1;
    } else {
      start = "top-=200% bottom";
      end = "bottom bottom";
      scrub = 1;
    }

    let timeline = gsap.timeline({
      scrollTrigger: {
        trigger: "#floating_line",
        start: start,
        end: end,
        scrub: scrub
      },
    });

    timeline.fromTo(
      this._line,
      {
        drawSVG: "0%",
      },
      {
        drawSVG: `${DrawSVGPlugin.getLength(this._line)}px`,
        duration: 1,
        ease: "none",
      }
    );
  }
}
